import { render, staticRenderFns } from "./LandingInitialization.vue?vue&type=template&id=64c34e06"
import script from "./LandingInitialization.vue?vue&type=script&lang=js"
export * from "./LandingInitialization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports